import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flagUrl } from '../../../constants.js';

import './flag.scss';

class Flag extends Component {
  render() {
    return (
      <span
        className="standings-flag-container"
        onClick={() => this.props.onClick(this.props.id)}
        title={this.props.title}
      >
        <img
          className="standings-flag-img"
          src={`${flagUrl}svg/4x3/${this.props.flagFileName}.svg`}
          alt={this.props.flagName}
        />
        <div className="standings-flag-title-over">{this.props.flagName}</div>
      </span>
    );
  }
}

Flag.propTypes = {
  onClick: PropTypes.func,
  flagName: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  hasWbsFeed: PropTypes.string
};

export default Flag;



// WEBPACK FOOTER //
// ./src/screens/components/flag/Flag.jsx